import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import Badge from "react-bootstrap/Badge";
import { CgWebsite } from "react-icons/cg";
import { BsGithub } from "react-icons/bs";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function ProjectCards(props) {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    pauseOnHover: true,
    arrows: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          autoplaySpeed: 3000,
        }
      }
    ]
  };

  return (
    <Card className="project-card-view">
      <div className="project-image-container">
        {Array.isArray(props.imgPath) ? (
          <Slider {...settings} className="project-slider">
            {props.imgPath.map((img, index) => (
              <div key={index} className="slider-item">
                <Card.Img
                  variant="top"
                  src={img}
                  alt={`${props.title} screenshot ${index + 1}`}
                  className="project-card-img"
                />
              </div>
            ))}
          </Slider>
        ) : (
          <Card.Img
            variant="top"
            src={props.imgPath}
            alt={`${props.title} screenshot`}
            className="project-card-img"
          />
        )}
      </div>
      
      <Card.Body className="project-card-body">
        <Card.Title className="project-title">{props.title}</Card.Title>
        
        {/* Tech Stack Badges */}
        {props.techStack && (
          <div className="tech-stack-container">
            {props.techStack.split(' • ').map((tech, index) => (
              <Badge 
                key={index} 
                bg="secondary" 
                className="tech-badge"
                style={{ 
                  margin: "2px 4px 8px 0", 
                  fontSize: "0.75em",
                  backgroundColor: "#6c5ce7",
                  color: "white"
                }}
              >
                {tech}
              </Badge>
            ))}
          </div>
        )}
        
        <Card.Text className="project-description">
          {props.description}
        </Card.Text>
        
        <div className="project-buttons">
          <Button variant="primary" href={props.ghLink} target="_blank" className="project-btn">
            <BsGithub /> &nbsp;
            {props.isBlog ? "Blog" : "GitHub"}
          </Button>

          {!props.isBlog && props.demoLink && (
            <Button
              variant="success"
              href={props.demoLink}
              target="_blank"
              className="project-btn demo-btn"
            >
              <CgWebsite /> &nbsp;
              {"Live Demo"}
            </Button>
          )}
        </div>
      </Card.Body>
    </Card>
  );
}

export default ProjectCards;
